import useSWR from "swr";
import MainGrid from "../mainGrid/mainGrid";
import { fetcherPost } from "../../GlobalGrid";
import { useState } from "react";
import { useSelector } from "react-redux";

export const GlobalGridRenderer = () => {
    const [selectedMoh, setSelectedMoh] = useState(1);
    const data = useSelector(state => state.globalGrid.data);
    const url = useSelector(state => state.globalGrid.url);

    const handleMohModifierChange = (e) => {
        setSelectedMoh(e);
    }

    const { data: newData, error, isLoading, mutate } = useSWR(url, fetcherPost(data), { revalidateOnFocus: false, revalidateOnReconnect: false, refreshWhenHidden: false });
    
    
    if (newData) {
        return (
            <>
                <MainGrid programId={0} categoryId={0} selectedModifier={selectedMoh} data={newData.dataSource} error={error} isLoading={isLoading} mutate={mutate} onMohModifierChange={handleMohModifierChange} />
            </>
        )
    }
    return null;
}
